import * as Yup from 'yup';

export const capitaliseFirstLetterOfEachWord = (string: string) =>
  typeof string === 'string'
    ? string
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : string;

export const addDividerBetweenString = (input: string[], divider: string) =>
  input.reduce((previousValue, currentValue, currentIndex, array) => {
    if (currentIndex === array.length) {
      return previousValue + currentValue;
    }
    return previousValue + divider + currentValue;
  });
export const uppercaseFirstLetter = (input: string): string => {
  return input.charAt(0).toUpperCase() + input.slice(1);
};

export const passwordValidation = Yup.string()
  .min(8)
  .matches(/^(?=.*[0-9])(?=.{8,})/, 'password must contain at least one number')
  .required('required');
